<template>
  <div
    style="
      background-color: #f5f5f5;
      overflow-x: hidden;
      padding-bottom: 1rem;
      min-height: 100vh;
      overflow-y: hidden;
    "
    v-if="productInfo"
  >
    <div v-wechat-title="($route.meta.title = productInfo.name)"></div>
    <!-- 顶部滑块-->
    <div class="swiper">
      <van-swipe class="my-swipe" indicator-color="white" @change="swiperChange" :autoplay="autoplay">
        <van-swipe-item v-if="productInfo.panoramaUrl">
          <iframe :src="productInfo.panoramaUrl" frameborder="0" style="height: 7.5rem; width: 100%; postion: relative"></iframe>
          <div class="panorama" @click="goPanorama()">
            <i class="iconfont icon-VR1" style="color: #fff"></i>
          </div>
        </van-swipe-item>
        <van-swipe-item v-if="productInfo.video && productInfo.video.url">
          <videoPlayer :url="productInfo.video.url" :cover="productInfo.video.cover" :time="productInfo.video.duration" ref="videoPlays" @onPlayerPlay="player"></videoPlayer>
        </van-swipe-item>
        <van-swipe-item v-for="(item, index) in banner" :key="index">
          <img :src="item" style="width: 100%; height: 7.5rem" preview="2" :large="item" v-load="'oProBig'" />
        </van-swipe-item>
      </van-swipe>
      <!-- 顶部人气-->
      <!-- <div class="swiper-help" v-if="getLivePopularizeRanking">
        <span class="span-l"
          >热榜人气 {{ top > 10 ? "No." : "TOP" }}{{ top }}</span
        >
        <div
          v-if="false"
          style="
            width: 1px;
            height: 0.28rem;
            background-color: #fff;
            display: inline-block;
            margin: 0 0.1rem;
          "
        ></div>
        <span class="span-r" v-if="false" @click="topRankClick">助力上榜</span>
        <i
          v-if="false"
          class="iconfont icon-xiangyou-copy"
          style="color: #fff; transform: scale(1.5); margin-left: 0.06rem"
        ></i>
      </div> -->
      <!-- 顶部直播-->
      <div class="swiper-live" v-if="productInfo.exhibitor.isLiving">
        <img v-if="productInfo.exhibitor.company.logo" :src="productInfo.exhibitor.company.logo" v-load="'oPicXS'" />
        <img v-else-if="exhibitionInfo && exhibitionInfo.exhibition && exhibitionInfo.exhibition.logo" :src="exhibitionInfo.exhibition.logo" v-load="'oPicXS'" />
        <img v-else src="@/assets/img/empty.png" />
        <p>Live</p>
        s
        <div class="go_look" @click="LinkAct(exActList)">Go</div>
      </div>
      <!-- 顶部3D图标-->
      <!--      <div class="swiper-view" @click="go_Dview" v-if="productInfo.view3DUrl">-->
      <!--        <i class="iconfont icon-d icon"></i>-->
      <!--        <span>3D视图</span>-->
      <!--      </div>-->
    </div>
    <!-- 咨询，访客，评价，预约-->
    <div class="product-title">
      <p>{{ productInfo.name }}</p>
      <span class="product-describe">{{ productInfo.selling }}</span>

      <div class="product-category">
        <p v-for="(item2, index2) in tagEn" :key="index2">
          <span class="van-ellipsis">{{ item2 }}</span>
        </p>
      </div>
      <div class="product-statistics">
        <div class="list">
          <div class="list-text">
            <span class="list-number">{{productInfo.exhibitor.talkCount||productInfo.exhibitor.talkCount==0 ? productInfo.exhibitor.talkCount : ' - '}}</span>
            <span class="list-title">Talks</span>
          </div>
          <div class="fenge"></div>
          <div class="list-text">
            <span class="list-number">{{ productInfo.viewCount||productInfo.viewCount==0 ? productInfo.viewCount : ' - '}}</span>
            <span class="list-title">Views</span>
          </div>
          <div class="fenge"></div>
          <div class="list-text">
            <span class="list-number">{{visitOpt.totalCount||visitOpt.totalCount==0 ? visitOpt.totalCount : ' - '}}</span>
            <span class="list-title">Visitor</span>
          </div>
          <!-- <div class="fenge"></div>

          <div class="list-text">
            <span class="list-number">{{productInfo.evaluateCount}}</span>
            <span class="list-title">评价</span>
          </div> -->
          <div class="fenge"></div>

          <div class="list-text">
            <span class="list-number">{{productInfo.advisoryCount||productInfo.advisoryCount==0  ? productInfo.advisoryCount : ' - '}}</span>
            <span class="list-title">Advisory</span>
          </div>
        </div>
      </div>
      <!-- <div class="product-view">
        <div class="product-view-line">
          <i class="iconfont icon-zhiboguankanshu-copy icon"></i>
          <span>{{ productInfo.viewCount }}</span>
          <i class="iconfont icon-guanzhu-xian icon"></i>
          <span>{{ productInfo.followCount }}</span>
          <i class="iconfont icon-dianzan icon"></i>
          <span>{{ likeOpt.totalCount }}</span>
        </div>
      </div> -->
    </div>
    <!-- 参展目标-->
    <!-- <div
      class="product-target"
      :style="!isTargetConShow ? 'padding-bottom:0' : ''"
      v-if="objectiveTags || productInfo.exhibitor.objectives"
    >
      <p class="p1">Objective(s)</p>
      <div class="product-category">
        <p v-for="(tags, index3) in objectiveTags" :key="index3">
          <span class="van-ellipsis">{{ tags }}</span>
        </p>
      </div>

      <div
        class="target_con"
        :class="{ target_show: isTargetConShow }"
        v-html="$service.replaceSpeace(productInfo.exhibitor.objectives)"
      ></div>
      <div
        @click="isTargetConShow = true"
        class="target_btn"
        
        v-if="!isTargetConShow"
      >
        {{ isTargetConShow ? "" : "MORE" }}
        <i
          class="iconfont icon-right-fill"
          :class="isTargetConShow ? 'shang' : ''"
          v-if="!isTargetConShow"
        ></i>
      </div>
    </div> -->
    <!-- 展商信息-->
    <div class="exhibition-data">
      <div class="exhibition-data-list" @click="goLinkExInvitation()">
        <img :class="{ square_logo: configLogoIsSquare }" :src="productInfo.exhibitor.company.logo" alt v-load="'oAvatar'" v-if="productInfo.exhibitor.company.logo" />
        <img
          :class="{ square_logo: configLogoIsSquare }"
          v-else-if="exhibitionInfo && exhibitionInfo.exhibition && exhibitionInfo.exhibition.logo"
          :src="exhibitionInfo.exhibition.logo"
          v-load="'oAvatar'"
        />
        <img :class="{ square_logo: configLogoIsSquare }" src="@/assets/img/empty.png" alt v-else />
        <div class="text">
          <div class="title">
            <p>
              {{ productInfo.exhibitor.company.nameEn }}
            </p>
            <!-- <span style="color: #666; display: flex; align-items: center">
              去逛逛
              <i
                class="iconfont icon-xiala"
                style="
                  transform: rotate(-90deg) scale(1.2);
                  display: inline-block;
                  color: #666;
                "
              ></i>
            </span> -->
          </div>
          <div class="bottom">
            <i class="iconfont icon-dizhi icon1" v-if="productInfo.exhibitor.boothInfo"></i>
            <span style="margin-right: 0.28rem">
              {{ productInfo.exhibitor.boothInfo }}
            </span>
            <i class="iconfont icon-biaoqian1 icon2" v-if="productInfo.exhibitor.categoryEn"></i>
            <span
              style="
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
                display: inline-block;
              "
              >{{ productInfo.exhibitor.categoryEn }}</span
            >
          </div>
          <div class="tongji">
            <div class="tips" v-if="productInfo.exhibitor && productInfo.exhibitor.productNumber > 0">
              <span class="b-span">
                <span class="r-span">{{ productInfo.exhibitor.productNumber }}</span>
                product(s)
              </span>
            </div>
            <div class="tips" v-if="productInfo.exhibitor && productInfo.exhibitor.activityNumber > 0">
              <span class="b-span">
                <span class="r-span">{{ productInfo.exhibitor.activityNumber }}</span>
                activity(s)
              </span>
            </div>
            <!-- <div class="tips">
              <span class="b-span">
                <span class="r-span">{{
                  productInfo.exhibitor.liveCount
                }}</span>
                live(s)
              </span>
            </div> -->
          </div>
        </div>
      </div>
    </div>
    <!-- 产品详情-->
    <img style="width: 100%; margin-bottom: 0.2rem; margin-top: 0.3rem" src="@assets/img/pro-detail.png" />
    <!-- <div class="comm_text" style="padding:0.31rem">{{productInfo.introductionEn}}</div> -->
    <div class="comm_text">
      <div v-for="(item, index1) in introduction" :key="index1">
        <!-- 文本 -->
        <p
          class="int-text"
          v-if="item.text"
          :style="{
            'font-size': item.text.fontSize,
            color: item.text.color,
            'text-align': item.text.position,
          }"
          v-html="$service.replaceSpeace(item.text.content)"
        ></p>
        <!-- 图片 -->
        <div class="int-img" v-if="item.picture && item.picture.type == 1">
          <div
            :style="{
              'padding-left': item.picture.padding + 'px',
              'padding-right': item.picture.padding + 'px',
            }"
          >
            <div v-for="(itm, idx) in item.picture.list" :key="idx" :style="{ 'margin-bottom': item.picture.spacing + 'px' }">
              <img :src="itm.url" preview="1" :large="itm.url" style="width: 100%; display: block" v-load="'oIntro'" />
            </div>
          </div>
        </div>
        <!-- 轮播图片 -->
        <div v-if="item.picture && item.picture.type == 2">
          <van-swipe class="my-swipe" indicator-color="white">
            <van-swipe-item v-for="(itm, idx) in item.picture.list" :key="idx">
              <img :src="itm.url" style="width: 100%; height: 7.5rem" preview="1" :large="itm.url" v-load="'oIntro'" />
            </van-swipe-item>
          </van-swipe>
        </div>
        <!-- 视频 -->
        <div class="int-video" style="position: relative" v-if="item.video">
          <videoPlayer :url="item.video.link" :cover="productInfo.video.Img" :time="productInfo.video.Time"></videoPlayer>
        </div>
      </div>
    </div>
    <div style="background-color: #fff; margin-top: 0.2rem">
      <!-- <evaluate
        :evalCount="productInfo.evaluateCount"
        :evalTags="productInfo.evaluateTags"
        :pro="true"
        :productId="productId"
        v-if="productInfo.evaluateCount>0"
      ></evaluate> -->
    </div>
    <div style="background-color: #fff; margin: 0.2rem 0" v-if="List.length">
      <div class="exhibits">
        <p>Other Product(s)</p>
      </div>
      <!-- 展品 -->
      <div class="exhibits_list">
        <div class="ex_list" v-if="List.length">
          <div v-for="(item, index) in List" :key="index" class="item">
            <div class="item_div" @click="goProductDetail(item.id)" v-if="item.id != productId">
              <div class="img_div">
                <div class="d_tag" v-if="item.view3DUrl"><i class="iconfont icon-d"></i>3D</div>
                <!--全景 -->
                <div class="img-v" v-if="item.panoramaUrl">
                  <i class="iconfont icon-VR1"></i>
                </div>
                <div class="play_video" v-if="item.video && JSON.parse(item.video).url">
                  <i class="iconfont icon-zhibo"></i>
                </div>
                <img v-if="item.video && JSON.parse(item.video).url" :src="JSON.parse(item.video).cover" />
                <img v-else-if="item.banner[0]" :src="item.banner[0]" alt v-load="'oProSmall'" />
                <img v-else src="@/assets/img/empty.png" />
              </div>
              <div class="item_info">
                <p class="van-ellipsis">{{ item.name }}</p>
                <p class="item_text van-multi-ellipsis--l2">
                  {{ proCategory[index] }}
                </p>
                <p class="item_text van-multi-ellipsis--l2">
                  {{ item.selling }}
                </p>
              </div>
            </div>
          </div>
        </div>
        <div v-else style="padding: 0.3rem 0 0.5rem; text-align: center">
          No content
        </div>
        <div class="more_btn loading" v-if="Loading && !finished"><img src="@assets/img/new/icon-loading.png" />Loading...</div>
        <div class="more_btn" @click="loadMore" v-else-if="!finished">
          MORE
          <i class="iconfont icon-right-fill"></i>
        </div>
      </div>
    </div>

    <div class="ex-list">
      <exTool :likeCount="likeOpt.totalCount" @share="share" :shareCount="productInfo.shareCount" :isLike="isLike" :isInquiry="isInquiry" :isD="isD" @like="likeClick" @go_Dview="go_Dview"></exTool>
    </div>
    <div class="shop_footer">
      <div class="f_item" @click="goLinkExInvitation()">
        <i class="iconfont i_zh icon-xunizhanting"></i>
        <p>Company</p>
      </div>
      <div class="f_item love" v-if="isFollower" @click="deProLove()">
        <i class="iconfont i_love icon-love"></i>
        <p>UnFollow</p>
      </div>
      <div class="f_item" v-else @click="addProLove()">
        <i class="iconfont i_love icon-guanzhu-xian"></i>
        <p>Follow</p>
      </div>
      <div class="f_item" @click="likeClick()" v-if="!isLike">
        <i class="iconfont icon-dianzan"></i>
        <p>Like</p>
      </div>
      <div class="f_item love" @click="likeClick()" v-else>
        <i class="iconfont icon-dianzanxuanzhong"></i>
        <p>Like</p>
      </div>
      <div class="f_btn">
        <!-- <span class="van-button">在线咨询</span> -->
        <!-- <span  class="van-button " :class="productInfo.exhibitor.hasReg?'already':''" @click="visitClick">{{productInfo.exhibitor.hasReg?"您已预约":"预约参观"}}</span> -->
        <!-- <span class="van-button" @click="visitClick">{{ "MESSAGE" }}</span> -->
        <span class="van-button" @click="inquiryClick">{{ "INQUIRY" }}</span>
      </div>
    </div>
    <!-- 点赞-->
    <Fabulous
      ref="Fabulous"
      :targetType="'product'"
      :targetId="productId"
      :isLike="isLike"
      @likeClick="likeClick"
      :likeOpt="likeOpt"
      :visitOpt="visitOpt"
      @likeMore="likeMore"
      @visitMore="visitMore"
    ></Fabulous>
    <liveShare ref="liveShare"></liveShare>
    <!-- 索取样品 -->
    <!-- <inquiry ref="inquiry"></inquiry> -->
    <!-- 询盘 -->
    <inquiryNew ref="inquiryNew"></inquiryNew>

    <helpMoney></helpMoney>
    <!-- 预约洽谈 -->
    <order ref="order"></order>
  </div>
</template>

<script>
import gql from "graphql-tag";
import { Dialog } from "vant";
import Fabulous from "@components/Fabulous";
import evaluate from "@/components/evaluate-list";
import liveShare from "@/components/live-share";
import exTool from "@/components/ex-tool";
// import inquiry from "@components/inquiry"; //索取样品
import inquiryNew from "@components/inquiry-new"; //索取样品
import helpMoney from "@/components/help-money";
import videoPlayer from "./videoPlayer";
import { ImagePreview } from "vant";
import order from "@components/order-model.vue"; // 预约洽谈
import { mapActions, mapGetters } from "vuex";
export default {
  name: "index",
  components: {
    Fabulous,
    evaluate,
    liveShare,
    exTool,
    // inquiry,
    inquiryNew,
    helpMoney,
    videoPlayer,
    order,
  },

  data() {
    return {
      top: "",
      hotVal: 0,
      Loading: false, //展品动态加载状态
      finished: false, //展品加载是否完成状态
      isTargetConShow: false,
      List: [], //展品列表
      pageSize: 3,
      totalCount: 0, //相关展品条数
      pageIndex: 0,
      startVal: 4,
      show: false,
      isShareV: false,
      isD: false,
      exInfo: "",
      isFollower: false,
      isLike: false,
      queryProduct: {},
      queryProductUser: {},
      queryProductLike: {},
      exhibitorId: "",
      proCategory: [],
      shareV: {
        content: "",
        poster: "",
      },
      optlll: {
        id: this.productId,
        isEx: false,
      },
      productInfo: {
        exhibitor: {
          company: {},
          products: {},
        },
        video: {
          Link: null,
        },
      },
      visitOpt: {
        //访问信息
        finished: false,
        page: 1,
        size: 20,
        totalCount: 0,
        items: [],
      },
      likeOpt: {
        //点赞信息
        finished: false,
        page: 1,
        size: 30,
        totalCount: 0,
        items: [],
      },
      exhibition: {},
      banner: [],
      introduction: null,
      introductionEn: null,
      objectiveTags: null,
      tag: null,
      tagEn: null,
      getLivePopularizeRanking: "",
      isInquiry: false, //索取样品
      autoplay: 3000,
      exActList: null, // 展商活动对象
      pictureList: [], //图片预览数组
      likeLoading: false,
      followerLoading: false,
    };
  },
  computed: {
    ...mapGetters({
      exhibitionId: "getExhibitionId",
      exhibitionInfo: "getExhibitionInfo",
      userId: "getUserId",
      userInfo: "getUserInfo",
      userRole: "getUserRole",
      configLogoIsSquare: "getConfigLogoIsSquare",
      myAdvisorySetting:'getMyAdvisorySetting'
    }),
    productId() {
      return this.$route.query.id;
    },
    isEx() {
      return false;
    },
  },
  mounted() {
    this.$Bus.$off("shareOk");
    this.$Bus.$on("shareOk", () => {
      this.productInfo.shareCount += 1;
      // console.log("哈哈，分享成功");
    });
    this.$Bus.$off("shareFail");
    this.$Bus.$on("shareFail", () => {
      // console.log("分享失败");
    });
    this.$preview.on("imageLoadComplete", (e, item) => {});
  },
  created() {
    this.getProductInfo(); 
    this.Productviewer({
      exhibitionId: this.exhibitionId,
      target: "product",
      targetId: this.productId,
    });
    this.$Myapollo.addExhibitionView();
  },
  methods: {
    ...mapActions({
      LinkUserEvaluation_pro: "linkTo/LinkUserEvaluation_pro", // 跳转到评价
      LinkToError: "linkTo/LinkToError",
      getAddedList: "connection/getAddedList",
      getSettingShare: "wxShare/getSettingShare", //分享配置展会
      generateShareTemplate: "wxShare/generateShareTemplate", //关键字替换
      ProductLike: "company/ProductLike", //点赞
      productfollower: "company/ProductFollower", //关注
      RemoveProductFollower: "company/RemoveProductFollower", //取消关注
      LinkExInvitation: "linkTo/LinkExInvitation", //跳转到邀请函
      LinkProduct: "linkTo/LinkProduct", // 跳转到产品详情页
      Productviewer: "company/Productviewer", //产品访问
      addViewLikeIp: "addViewLikeIp",
      addViewLikeIpByCountry: "addViewLikeIpByCountry",
      // addhotViewer: "company/addhotViewer", //展品热榜浏览
      LinkAct: "linkTo/LinkAct", //跳转到活动页
      exVisitor: "my/exVisitor", //
      graphqlPost: "en/graphqlPostByZXS", //阿波罗接口方法
      getUserAdvisorySetting:"getUserAdvisorySetting"
    }),

    wCount(value) {
      //过万处理
      let num = value;
      if (value > 9999) {
        //大于9999显示x.xx万
        num = Math.floor(value / 100) / 100 + "w";
      } else {
        num = value;
      }
      return num;
    },
    getCate(arr) {
      console.log(arr, "---");
      let str = "";
      if (arr && arr[0]) {
        for (let i = 0; i < arr.length; i++) {
          str += str ? "," + arr[i].Value : arr[i].Value;
        }
        return str;
      } else {
        return "";
      }
    },
    getbannerImg(index) {
      console.log(index);
      ImagePreview({
        images: this.banner,
        showIndex: true,
        loop: true,
        startPosition: index,
      });
    },
    //点击预览图片
    getImg(item) {
      console.log(item);
      ImagePreview({
        images: this.pictureList,
        showIndex: false,
        loop: false,
        startPosition: item,
      });
      // ImagePreview(
      //   ['https://img.yzcdn.cn/vant/apple-1.jpg']
      // );
    },
    goexLiving() {},
    // 判断视频是否在播放
    player(autoplay) {
      this.autoplay = autoplay;
      console.log(autoplay, "autoplay");
    },
    swiperChange() {
      this.autoplay = 3000;
      if (this.$refs.videoPlays) {
        //如果改变的时候视频正在播放，则暂停
        this.$refs["videoPlays"].Pause();
      }
    },
    //跳转3D页面
    go_Dview() {
      window.location.href = this.productInfo.view3DUrl;
    },
    getData(isLoad = false) {
      let query = gql`
        query queryProduct($page: Int!, $size: Int!, $where: String!, $order: String) {
          queryProduct(query: { page: $page, size: $size, where: $where, order: $order }) {
            hasNextPage
            indexFrom
            pageIndex
            pageSize
            totalCount
            items {
              id
              name
              nameEn
              selling
              sellingEn
              banner
              view3DUrl
              category
              categoryEn
              panoramaUrl
              video
            }
          }
        }
      `;
      let where = {
        Equal: {
          n: "exhibitorId",
          v: this.exhibitorId,
        },
        Equal2: {
          n: "auditState", // 审核通过
          v: 1,
        },
        NotEqual: {
          n: "id",
          v: this.productId,
        },
      };
      let order = [
        {
          N: "showIndex",
          v: 0,
        },
        {
          N: "createAt",
          v: 0,
        },
      ];
      this.$apollo.addSmartQuery("queryProduct", {
        query: query,
        variables: {
          page: this.pageIndex,
          size: this.pageSize,
          where: JSON.stringify(where),
          order: JSON.stringify(order),
        },
        fetchPolicy: "network-only", //清理缓存
        result(data) {
          console.log(data, "22222222222222222");
          this.totalCount = data.data.totalCount;
          let res = JSON.parse(JSON.stringify(data.data.queryProduct));
          // let res=data.data.queryProduct;

          if (res && res.items.length) {
            res.items.forEach((el) => {
              let arr = [];
              if (el.categoryEn) {
                el.categoryEn = JSON.parse(el.categoryEn)[0];
                arr.push(el.categoryEn.Value);
                if (el.categoryEn.lists && el.categoryEn.lists.length) {
                  el.categoryEn.lists.forEach((l) => {
                    arr.push(l.Value);
                  });
                }
              }

              // this.proCategory.push(Category)

              console.log(arr.join("/"), "proCategory");
              this.proCategory.push(arr.join("/"));
              if (el.banner && !Array.isArray(el.banner)) {
                el.banner = JSON.parse(el.banner);
              } else if (!Array.isArray(el.banner)) {
                el.banner = [];
              }
            });
          }
          console.log(this.proCategory, "2211233132111");
          if (this.pageIndex == 1) {
            this.List = res.items;
          } else {
            this.List = [...new Set([...this.List, ...res.items])];
          }
          // console.log('this.List',this.List);
          this.Loading = false;
          if (isLoad) {
            this.pageIndex = res.pageIndex;
          } else {
            this.pageIndex = 0;
            this.pageSize = 10;
          }
          if (!res.hasNextPage) {
            this.finished = true;
          }
        },
        error(err) {
          this.Loading = false;
          console.log("err", err);
        },
      });
    },
    //更多
    loadMore() {
      if (this.finished) return;
      this.Loading = true;
      this.pageIndex += 1;
      this.pageSize == 10;
      this.getData(true);
    },
    //相关展品跳转
    goProductDetail(productId) {
      this.LinkProduct(productId);
      location.reload();
    },
    //前往邀请函
    goLinkExInvitation() {
      let opt = {
        exhibitorId: this.exhibitorId,
        exhibitionId: this.exhibitionId,
      };
      this.LinkExInvitation(opt);
    },
    //全景外链
    goPanorama() {
      window.location.href = this.productInfo.panoramaUrl;
    },
    //获取展品信息
    async getProductInfo() {
      let query = gql`
        query product($id: Guid!) {
          product(id: $id) {
            auditRemark #审核说明
            auditState #审核状态，-1：不通过、0：待审核、1：通过
            banner
            bibValue #竞价榜排名，大于表示参与了竞价
            category #产品类别
            certification #产品认证
            certificationQuality #质量体系认证
            channel #适用渠道
            commentCount #留言次数
            compId #公司Id
            createAt #创建时间
            panoramaUrl
            advisoryCount
            evaluateTags {
              #获取展商评价标签
              evaluateCount #评价数
              isShow #是否显示
              name #标签名称
              productId #展品ID
            }
            exhibitionId #展会ID
            exhibitor {
              #参展信息
              activityLiving {
                id
                acvitityType
                hasLive
                liveAuditState
              }
              businesses(num: 3) {
                isSample
              }
              categoryEn
              thinkCount #预约参观数
              objectives #参展目标
              objectiveTags #参展目标标签 多个按;隔开
              advisoryCount #咨询人数
              talkCount
              activityCount #活动数
              activityNumber
              productNumber
              boothInfo #展位信息
              category #展品类别
              proCount #产品数
              liveCount
              isLiving

              id
              products {
                #展商展品
                name
                selling
                sellingEn
                category
              }
              company {
                #公司信息
                name
                nameEn
                logo
                region
                id
              }
            }
            evaluateCount #评价数
            exhibitorId #参展信息
            followCount #关注人数
            helpMoney #助力金额
            id
            introduction #产品介绍
            introductionEn
            isDeleted #是否删除
            isDisplay #推荐显示，展商自己推荐到店铺首页和专题页
            isShow #是否显示
            keyword #关键字
            lookCount #展示的人次，可能看到
            name #产品名称
            nameEn
            selling #产品卖点，一句话介绍
            sellingEn
            shareCount #分享次数
            tag #标签
            tagEn
            talkCount #连线次数
            topicEnd #置顶结束时间
            topicIndex #排序置顶优先级
            topicStart #置顶开始时间
            topicType #置顶方式，0：不置顶、1：推荐 、2：置顶
            updateAt #修改时间
            userCount #浏览人数
            video #视频
            view3DUrl #产品3d浏览链接
            viewCount #浏览次数
          }
        }
      `;
      this.$apollo.addSmartQuery("product", {
        query: query,
        variables: {
          id: this.productId,
        },
        fetchPolicy: "no-cache",
        result(res) {
          this.productInfo = res.data.product;
          if (!this.productInfo) {
            this.LinkToError();
            return;
          }
          this.banner = eval(this.productInfo.banner);
          this.exhibitorId = this.productInfo.exhibitorId;
          if (this.productInfo.exhibitor.objectiveTags) {
            this.objectiveTags = this.productInfo.exhibitor.objectiveTags.split(";");
          }
          if (this.productInfo.tagEn) {
            this.tagEn = this.productInfo.tagEn.split(";");
          } else if (this.productInfo.tag) {
            this.tagEn = this.productInfo.tag.split(";");
          }
          //获取活动的信息
          this.exActList = this.productInfo.exhibitor.activityLiving;
          console.log(this.exActList, "exActList");
          // 索取样品
          if (this.productInfo.exhibitor.businesses.length > 0) {
            this.isInquiry = this.productInfo.exhibitor.businesses[0].isSample;
          }
          //格式化参展目标
          if (this.productInfo.exhibitor.objectives) {
            console.log(this.productInfo.exhibitor.objectives, "this.productInfo.objectives");
            this.productInfo.exhibitor.objectives = this.$service.replaceSpeace(this.productInfo.exhibitor.objectives);
          }
          // 是否关注
          this.isFollower = this.productInfo.isFollow;
          //格式化详情信息
          if (this.productInfo.introduction.indexOf("[") !== -1) {
            // this.productInfo.introduction = eval(this.productInfo.introduction);

            this.introduction = JSON.parse(this.productInfo.introduction);
            console.log(this.introduction, "eleleleleelel");
            this.introduction.forEach((el) => {
              if (el.picture && el.picture.list && el.picture.list.length) {
                this.pictureList.push(el.picture.list[0].url);
              }
            });
            console.log(this.pictureList, " this.pictureList");
          }
          //视频
          if (this.productInfo.video && this.productInfo.video.indexOf("{") !== -1) {
            this.productInfo.video = JSON.parse(res.data.product.video);
          }
          //类别
          if (this.productInfo.exhibitor.category && this.productInfo.exhibitor.category.indexOf("[") !== -1) {
            let category = JSON.parse(this.productInfo.exhibitor.category);
            this.productInfo.exhibitor.category = this.getCate(category);
          }
          //类别
          if (this.productInfo.exhibitor.categoryEn && this.productInfo.exhibitor.categoryEn.indexOf("[") !== -1) {
            let categoryEn = JSON.parse(this.productInfo.exhibitor.categoryEn);
            this.productInfo.exhibitor.categoryEn = this.getCate(categoryEn);
          }
          if (this.productInfo.view3DUrl) {
            this.isD = true;
          }
          if (this.productInfo.panoramaUrl) {
            this.autoplay = 6000000;
          }
          console.log(this.productInfo.video, "this.productInfo.video");
          if (this.productInfo.panoramaUrl) {
            this.autoplay = 600000;
          }
          this.init();
          this.$nextTick(() => {
            //是否显示参展目标的更多
            if (document.querySelector(".target_con") && document.querySelector(".target_con").scrollHeight > 60) {
              this.isTargetConShow = false;
            } else {
              this.isTargetConShow = true;
            }
            this.checkShareInfo();
            this.getShareData();
          });
        },
      });
    },
    //获取点赞信息
    getLike() {
      let query = gql`
        query($query: _Any!) {
          proipActionCountQuery: ipActionCountQuery {
            page(query: $query) {
              hasNextPage
              pageIndex
              totalCount
              items {
                id
                country
                countryCode
                likeCount
                targetType
                viewCount
              }
            }
          }
        }
      `;
      let where = {
        Equal: {
          n: "targetId",
          v: this.productId,
        },
        Equal_targetType: {
          n: "targetType",
          v: "product",
        },
        GreaterThan: {
          n: "likeCount",
          v: 0,
        },
      };
      let order = [
        {
          N: "likeCount",
          v: 0,
        },
      ];
      let opt = {
        page: this.likeOpt.page,
        size: this.likeOpt.size,
        where: where,
        order: order,
      };
      this.$apollo.addSmartQuery("proipActionCountQuery", {
        query: query,
        variables: {
          query: opt,
        },
        fetchPolicy: "network-only", //清理缓存
        result(data) {
          console.log(data, "点赞data");
          let res = JSON.parse(JSON.stringify(data.data.proipActionCountQuery.page));
          res.items.forEach((el) => {
            el.countryCode = el.countryCode.toLowerCase();
          });
          // console.log(this.pageIndex,'点赞data')
          if (this.likeOpt.page == 1) {
            this.likeOpt.items = res.items;
          } else {
            this.likeOpt.items = [...new Set([...this.likeOpt.items, ...res.items])];
          }
          this.likeOpt.page = res.pageIndex;
          this.likeOpt.totalCount = res.totalCount;
          if (!res.hasNextPage) {
            this.likeOpt.finished = true;
          }
        },
        error(err) {
          console.log("err", err);
        },
      });
    },
    //获得访问信息
    getVisit(isF = false) {
      let query = gql`
        query($query: _Any!) {
          proipActionCountQueryView: ipActionCountQuery {
            page(query: $query) {
              hasNextPage
              pageIndex
              totalCount
              items {
                id
                country
                countryCode
                likeCount
                targetType
                viewCount
              }
            }
          }
        }
      `;
      let where = {
        Equal: {
          n: "targetId",
          v: this.productId,
        },
        Equal_targetType: {
          n: "targetType",
          v: "product",
        },
        GreaterThan: {
          n: "viewCount",
          v: 0,
        },
      };
      let order = [
        {
          N: "viewCount",
          v: 0,
        },
      ];
      let opt = {
        page: this.visitOpt.page,
        size: this.visitOpt.size,
        where: where,
        order: order,
      };
      let body = {
        query: query,
        variables: {
          query: opt,
        },
      };
      this.$apollo.addSmartQuery("proipActionCountQueryView", {
        query: query,
        variables: {
          query: opt,
        },
        fetchPolicy: "network-only",
        result(data) {
          console.log(data, "访问data");
          let res = JSON.parse(JSON.stringify(data.data.proipActionCountQueryView.page));
          res.items.forEach((el) => {
            el.countryCode = el.countryCode.toLowerCase();
          });

          if (this.visitOpt.page == 1) {
            this.visitOpt.items = res.items;
          } else {
            this.visitOpt.items = [...new Set([...this.visitOpt.items, ...res.items])];
          }
          this.visitOpt.page = res.pageIndex;
          this.visitOpt.totalCount = res.totalCount;
          if (!res.hasNextPage) {
            this.visitOpt.finished = true;
          }
          if (isF) {
            this.$refs.Fabulous.init();
          }
        },
        error(err) {
          console.log("err", err);
        },
      });
    },
    //获取参展信息
    getExhibition() {
      let query = gql`
        query exhibition($id: Guid!) {
          exhibition: exhibition(id: $id) {
            name
            coordinate #展馆指坐标
          }
        }
      `;
      this.$apollo.addSmartQuery("exhibition", {
        query: query,
        variables: {
          id: this.exhibitionId,
        },
        result(data) {
          this.exhibition = data.data.exhibition;
          console.log(data.data.exhibition, "wwwwwwwwwwwwwwwwwwwwwwww");
        },
      });
    },
    //获取展商信息
    getInfo() {
      // console.log('调用getInfo');
      const query = gql`
        query exhibitor($id: Guid!, $userId: String!) {
          giveExInfo: exhibitor(id: $id) {
            banner #主图海报
            id
            video #主图视频
            objectives #参展目标
            objectiveTags #参展目标标签 多个按;隔开
            userCount #浏览人数
            shareCount #分享次数
            likeCount #点赞数
            advisoryCount #咨询人数
            talkCount
            activityCount #活动数
            boothInfo
            evaluateCount #评价数
            evaluateTags {
              #评价标签
              evaluateCount #评价数
              name
            }
            proCount #产品数量
            isLiving #是否正在直播
            compId #公司id
            company {
              #公司信息
              id
              name
              nameEn
              logo
              summary #简介
              region #地区
              category #产品类别
              introduction #公司详细 简介
            }
          }
        }
      `;
      this.$apollo.addSmartQuery("giveExInfo", {
        query: query,
        variables: {
          id: this.exhibitorId,
          userId: this.userInfo.userId,
        },
        fetchPolicy: "network-only", //清理缓存
        result(res) {
          console.log(res, "请求回来了");
          let data = JSON.parse(JSON.stringify(res.data.giveExInfo));
          // let data=res.data.giveExInfo;
          if (data) {
            if (data.video && data.video.indexOf && data.video.indexOf("{") !== -1) {
              data.video = JSON.parse(data.video);
            }
            if (data.company && data.company.category && data.company.category.indexOf("[") !== -1) {
              let cateArr = JSON.parse(data.company.category);
              data.company.category = this.getCate(cateArr);
            }
            data.talkCount = this.wCount(data.talkCount); //咨询人数
            data.userCount = this.wCount(data.userCount); //浏览人数
            data.productNumber = this.wCount(data.productNumber); //浏览人数
            data.activityNumber = this.wCount(data.activityNumber); //活动数
            data.evaluateCount = this.wCount(data.evaluateCount); //评价数
            for (let i = 0; i < data.evaluateTags.length; i++) {
              data.evaluateTags.evaluateCount = this.wCount(data.evaluateTags.evaluateCount);
            }
            this.exInfo = data;
            // this.isFollower=this.exInfo.isFollow;

            console.log("exInfo12", this.exInfo);
          }
        },
        error(err) {},
      });
    },
    //获取产品热榜排行
    getProductRank() {
      const query = gql`
        query getLivePopularizeRanking($exhibitionId: Guid!, $productId: Guid!) {
          getLivePopularizeRanking(exhibitionId: $exhibitionId, productId: $productId) {
            id
            no
            power
          }
        }
      `;
      this.$apollo.addSmartQuery("getLivePopularizeRanking", {
        query: query,
        variables: {
          exhibitionId: this.exhibitionId,
          productId: this.productId,
        },
        fetchPolicy: "no-cache",
        result(res) {
          console.log(res, "热榜排行");
          let data = JSON.parse(JSON.stringify(res.data.getLivePopularizeRanking));
          if (data) {
            this.top = data.no || "";
            this.hotVal = data.power;
          }
        },
        error(err) {
          console.log("err", err);
        },
      });
    },
    //获取点赞和关注
    async getFollowAndLikeState() {
      let query = `
                 query{
                       productFollowQuery{
                       isFollow(productId:"${this.productId}",userId:"${this.userInfo.userId}")
                     }
                       productLikeQuery{
                       isLike(productId:"${this.productId}",userId:"${this.userInfo.userId}")
                    }
                }
                `;
      let opt = {
        query: query,
        variables: {},
      };

      let data = await this.graphqlPost(opt);
      // this.isFollower=this.exInfo.isFollow;
      console.log(data, "iiiiiiii");
      let res = JSON.parse(JSON.stringify(data.data));
      this.isFollower = res.productFollowQuery.isFollow;
      this.isLike = res.productLikeQuery.isLike;
    },
    async init() {
      console.log(this.exhibitorId, "exhibitorId");

      console.log(this.userInfo, "this.userInfo");
      let userInfo = {
        nickName: this.userInfo.nickName,
        avatarUrl: this.userInfo.avatarUrl,
      };
      let opt = {
        productId: this.productId,
        exhibitionId: this.exhibitionId,
        exhibitorIdL: this.exhibitorId,
        userId: this.userInfo.userId,
        userInfo: JSON.stringify(userInfo),
      };
      // let viewopt = {
      //   exhibitionId: this.exhibitionId,
      //   target: "product",
      //   targetId: this.productId,
      //   userId: this.userId || "",
      // };
      let body = {
        targetType: "product",
        targetId: this.productId,
        actionType: "view",
      };
      if (this.userInfo && this.userInfo.country) {
        body.country = this.userInfo.country;
        await this.addViewLikeIpByCountry(body);
      } else {
        await this.addViewLikeIp(body);
      }
      //this.getInfo();
      this.getLike();
      this.getVisit(true);
      this.getExhibition();
      this.checkForm();
      this.getData();
      this.getProductRank();
      if (this.userInfo) {
        this.getFollowAndLikeState();
      }

      this.$Myapollo.getUserInfo(this);
    },
    // loadMore() {
    //     if (this.Finished) return;
    //     this.pageIndex += 1;
    //     this.init();
    // },
    //侧边预约参观
    makeVisit() {
      this.$refs.order.open();
      return;
      Dialog.confirm({
        title: "预约参展",
        message: "是否向该展商提交预约信息",
      })
        .then(async () => {
          let opt = {
            exhibitionId: this.exhibitionId,
            exhibitorId: this.exhibitorId,
            memberId: this.userInfo.id,
          };
          let res = await this.exVisitor(opt);
          if (res.result) {
            this.$toast.success("Success to send");
            this.productInfo.exhibitor.hasReg = true;
          } else {
            this.$toast.fail("Failed to send ");
          }
          // on confirm
        })
        .catch(() => {
          this.$toast.fail("取消预约");
          // on cancel
        });
    },
    //关注产品
    async addProLove() {
      if (this.followerLoading) {
        return
      }
      if (!this.userInfo) {
        this.$Myapollo.NoUserInfo(this);
        return;
      }
      this.followerLoading = true;
      let userInfo = {
        name: this.userInfo.name,
        avatarUrl: this.userInfo.avatarUrl,
        nickName: this.userInfo.nickName,
      };
      let opt = {
        productId: this.productId,
        exhibitionId: this.exhibitionId,
        exhibitorId: this.exhibitorId,
        userId: this.userInfo.userId,
        userInfo: JSON.stringify(userInfo),
      };
      let result = await this.productfollower(opt);
      if (result.message == "已关注") {
        this.isFollower = true;
        this.$toast.success("Success");
      } else {
        this.isFollower = false;
        this.$toast.success(result.message);
      }
      this.followerLoading = false;
    },
    //关注产品
    async deProLove() {
      //判断是否登录
      if (!this.userInfo) {
        this.$Myapollo.NoUserInfo(this);
        return;
      }
      // 取消关注
      let body = {
        productId: this.productId,
        userId: this.userInfo.userId,
      };
      let result = await this.RemoveProductFollower(body);
      // console.log(result,'213
      if (result.result) {
        this.isFollower = false;
        this.$toast.success("Cancel");
      } else {
        this.isFollower = true;
        this.$toast.success(result.message);
      }
    },
    //侧边点赞
    async likeClick() {
      if (this.likeLoading) {
        return
      }
      let body = {
        targetType: "product",
        targetId: this.productId,
        actionType: "like",
      };
      let res = null;
      if (this.userInfo) {
        if (this.isLike) {
          this.$toast("You've already liked it");
          return;
        }
         this.likeLoading = true;
        let userInfo = {
          name: this.userInfo.name || "",
          avatarUrl: this.userInfo.avatarUrl,
          nickName: this.userInfo.nickName,
          flagStyle: this.userInfo.flagStyle || "",
        };
        console.log(userInfo, "this.userInfo.userId,");
        let opt = {
          productId: this.productId,
          exhibitionId: this.exhibitionId,
          exhibitorId: this.productInfo.exhibitor.id,
          userId: this.userInfo.userId,
          userInfo: JSON.stringify(userInfo),
        };
        let res1 = await this.ProductLike(opt);
        console.log(res1, "点赞接口");
        if (res1.result) {
          this.$toast.success("Like Success");
          // this.$apollo.queries.giveExInfo.refresh();
          this.isLike = true;
          // this.$apollo.queries.queryProductLike.refresh();
        } else {
          this.$toast.fail("Like failed");
        }
        if (this.userInfo.country) {
          body.country = this.userInfo.country;
          res = await this.addViewLikeIpByCountry(body);
        }
      } else {
         this.likeLoading = true;
        res = await this.addViewLikeIp(body);
      }
      // res = await this.addViewLikeIp(body);
      if (res.result) {
        this.$toast.success("Like Success");
        // this.$apollo.queries.giveExInfo.refresh();
        // this.isLike = true;
        // this.$apollo.queries.queryProductLike.refresh();
      } else {
        this.$toast.fail("Like failed");
      }
      this.likeLoading = false;
    },
    //侧边索取样品
    // askforClick() {
    //   this.$store.commit("company/setExhibitorId", this.exhibitorId);
    //   this.$store.commit("company/setCompanyId", this.companyId);
    //   let exInfo = {
    //     compLogo: this.exInfo.company.logo,
    //     compName: this.exInfo.company.name,
    //     boothInfo: this.exInfo.boothInfo,
    //   };
    //   this.$refs.inquiry.open(exInfo);
    // },
    // 获取自定义分享
    async getShareVal() {
      let res = await this.getSettingShare({
        id: this.exhibitionId,
        name: "share.product.en.config",
      });
      if (res) {
        let shareMsg = JSON.parse(res);
        let objTemp = {
          pro: this.productInfo.name,
          CompanyName: this.productInfo.exhibitor.company.nameEn,
          booth: this.productInfo.exhibitor.boothInfo,
          selling: this.productInfo.selling,
        };
        let opt = {
          temp: shareMsg.content,
          objTemp: objTemp,
        };
        let optdes = {
          temp: shareMsg.des,
          objTemp: objTemp,
        };
        let msg = await this.generateShareTemplate(opt);
        let des = await this.generateShareTemplate(optdes);
        shareMsg.content = msg;
        shareMsg.des = des;
        this.shareV = shareMsg;
      }
      this.isShareV = true;
    },
    //预约参观
    visitClick() {
      // if(this.productInfo.exhibitor.hasReg){
      //   return
      // }
      if (this.userRole.toUpperCase() == "VISITOR") {
        this.$Myapollo.unverifiedDialog(this, true, this.exhibitionId);
      } else {
        this.makeVisit();
      }
    },
    //询盘
    async inquiryClick() {
      if (!this.userInfo) {
        this.$Myapollo.NoUserInfo(this);
      } else if (this.userRole.toUpperCase() == "VISITOR") {
        this.$Myapollo.unverifiedDialog(this, true, this.exhibitionId);
      } else if (this.userInfo && this.userInfo.inMember.isBlacklist) {
        this.$toast.fail("You do not have access");
        return;
      } else {
        if(!this.myAdvisorySetting || this.myAdvisorySetting.enquiryDayNumber==0){
          await this.getUserAdvisorySetting()
        }
        console.log(this.myAdvisorySetting,'哈哈询盘次数')
        if(this.myAdvisorySetting.enquiryDayNumber>0){
          let opt = {
            exhibitorId: this.exhibitorId,
            productName: this.productInfo.name,
            productId: this.productId,
          };
          this.$refs.inquiryNew.open(opt);
        }else{
          this.$toast.fail("Your number of inquiries has reached the limit");
        }
      }
    },
    //侧边分享点击
    async share() {
      console.log("侧边分享");
      // if (!this.isShareV) {
      //   await this.getShareVal();
      // }
      // let addr = this.productInfo.exhibitor.company.region;
      let opt = {
        title: "Recommend a product for you",
        bannerTitle: this.productInfo.name, //展品名字
        subhead: this.productInfo.selling,
        banner: this.banner.slice(0, 3),
        type: "pro",
      };
      this.$nextTick(() => {
        this.$refs["liveShare"].open(opt);
      });
      console.log("侧边分享");
    },
    //分享标题，内容，图片
    async getShareData() {
      await this.getShareVal();
      let shareData = {
        title: this.shareV && this.shareV.content ? this.shareV.content : "Recommend a product for you",
        desc: this.shareV && this.shareV.des ? this.shareV.des : this.productInfo.name,
        imgUrl: JSON.parse(this.productInfo.banner).length > 0 ? JSON.parse(this.productInfo.banner)[0] : "",
      };
      // console.log('shareD1ata',shareData)
      this.$nextTick(() => {
        this.$refs.liveShare.shareTo(shareData);
      });
    },
    //设置分享信息
    async checkShareInfo() {
      if (!this.userInfo) {
        return;
      }
      let userInfo = {
        name: this.userInfo.nickName || this.userInfo.name,
        avatarUrl: this.userInfo.avatarUrl,
      };
      if (this.$route.query.hotId) {
        this.$store.commit("wxShare/setFromType", 2); // 判断是否来源于热榜
        let body = {
          popularzeId: this.$route.query.hotId,
          userId: this.userInfo.userId,
          userInfo: JSON.stringify(userInfo),
          fromType: 2,
        };
        this.$store.commit("wxShare/setFromData", body);
      } else {
        this.$store.commit("wxShare/setFromType", 3); // 产品的分享类型
        let body = {
          productId: this.productId,
          exhibitionId: this.exhibitionId,
          exhibitorId: this.productInfo.exhibitorId,
          userId: this.userInfo.userId,
          userInfo: JSON.stringify(userInfo),
          fromType: 0,
        };
        this.$store.commit("wxShare/setFromData", body);
      }
    },
    //点赞更多
    likeMore() {
      if (this.likeOpt.finished) return;
      this.likeOpt.page += 1;
      this.getLike();
    },
    //访问更多
    visitMore() {
      if (this.visitOpt.finished) return;
      this.visitOpt.page += 1;
      this.getVisit();
    },
    async checkForm() {
      let userInfo = {
        name: this.userInfo.nickName || this.userInfo.name,
        avatarUrl: this.userInfo.avatarUrl,
      };
      if (this.$route.query.hotId) {
        this.$store.commit("wxShare/setFromType", 2); // 判断是否来源于热榜
        let body = {
          popularzeId: this.$route.query.hotId,
          userId: this.userInfo.userId,
          userInfo: JSON.stringify(userInfo),
          fromType: 2,
        };
        this.$store.commit("wxShare/setFromData", body);
        let data = await this.addhotViewer(body);
      } else {
        this.$store.commit("wxShare/setFromType", 3); // 产品的分享类型
        let body = {
          productId: this.productId,
          exhibitionId: this.exhibitionId,
          exhibitorId: this.exhibitorId,
          userId: this.userInfo.userId,
          userInfo: JSON.stringify(userInfo),
          fromType: 0,
        };
        this.$store.commit("wxShare/setFromData", body);
      }
    },
    topRankClick() {
      this.$Bus.$emit("helpClick");
    },
    goEvalua() {
      if (!this.userInfo.phone) {
        this.$Myapollo.unverifiedDialog(this);
        return;
      }
      let opt = {
        id: this.productId,
        exhibitorId: this.productInfo.exhibitorId,
      };
      this.LinkUserEvaluation_pro(opt);
    },
  },
};
</script>

<style scoped lang="scss">
.panorama {
  position: absolute;
  top: 3.25rem;
  left: 50%;
  margin-left: -0.5rem;
  width: 1rem;
  height: 1rem;
  background-color: rgba(0, 0, 0, 0.1);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  i {
    transform: scale(2);
    color: #fff;
  }
}
.swiper {
  position: relative;

  &-help {
    height: 0.64rem;
    background-color: rgba(0, 0, 0, 0.35);
    border-radius: 32px;
    position: absolute;
    top: 0.3rem;
    left: 0.3rem;
    display: flex;
    align-items: center;
    .span-l {
      font-size: 0.2rem;
      color: #fff;
      margin-left: 0.24rem;
      margin-right: 0.24rem;
    }
    .span-r {
      font-size: 0.24rem;
      color: #fff;
    }
  }
  &-live {
    height: 1.6rem;
    width: 0.96rem;
    background: rgba(0, 0, 0, 0.35);
    padding: 0.2rem 0 0.05rem;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    align-items: center;
    border-radius: 0.2rem;
    justify-content: space-between;
    color: #fff;
    position: fixed;
    top: 0.9rem;
    right: 0.3rem;
    z-index: 1;
    img {
      width: 0.44rem;
      height: 0.44rem;
      border-radius: 50%;
    }
    p {
      font-size: 0.2rem;
    }
    .go_look {
      font-size: 0.2rem;
      width: 0.8rem;
      height: 0.35rem;
      display: flex;
      justify-content: center;
      align-items: center;
      background-image: linear-gradient(90deg, #ff416c 0%, #ff4b2b 100%);
      border-radius: 0.18rem;
    }
  }
  &-view {
    width: 0.92rem;
    height: 0.92rem;
    background-image: linear-gradient(90deg, #ff416c 0%, #ff4b2b 100%), linear-gradient(#ff5c00, #ff5c00);
    background-blend-mode: normal, normal;
    border-radius: 50%;
    position: absolute;
    top: 3.88rem;
    right: 0.3rem;
    text-align: center;
    .icon {
      color: #fff;
      display: block;
      transform: scale(2);
      margin-top: 0.16rem;
    }
    span {
      color: #fff;
      display: block;
      margin-top: 0.04rem;
      font-size: 0.18rem;
    }
  }
}
.my-swipe .van-swipe-item {
  color: #fff;
  font-size: 20px;
  text-align: center;
  height: 7.5rem;
}
/**商品描述样式**/
.product-title {
  padding: 0.3rem;
  background-color: #fff;
  > p {
    width: 6.5rem;
    font-size: 0.34rem;
    font-weight: bold;
    color: #222;
  }
  .product-describe {
    width: 6.5rem;
    font-size: 0.26rem;
    color: #4d4d4d;
    display: inline-block;
    margin-top: 0.14rem;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    overflow: hidden;
  }

  .product-statistics {
    width: 6.9rem;
    height: 1.07rem;
    background-color: #fff;
    box-shadow: 0px 0px 20px 0px rgba(0, 0, 0, 0.1);
    border-radius: 10px;
    margin-top: 0.2rem;
    .list {
      padding: 0.2rem 0;
      display: flex;
      align-items: center;
      .list-text {
        width: 1.7rem;
        text-align: center;
      }
      .fenge {
        width: 1px;
        height: 0.52rem;
        background-color: #dddddd;
      }
      &-number {
        font-size: 0.3rem;
        font-weight: bold;
        color: #ff5c00;
        display: block;
      }
      &-title {
        font-size: 0.22rem;
        display: block;
      }
    }
  }
  .product-view {
    margin-top: 0.35rem;
    color: #999;
    &-line {
      display: flex;
      align-items: center;
    }
    .icon {
      font-size: 0.3rem;
    }
    span {
      margin-left: 0.05rem;
      margin-right: 0.3rem;
    }
  }
}
/**参展目标**/
.product-target {
  margin-top: 0.2rem;
  background-color: #fff;
  padding: 0.3rem;
  .target_con {
    line-height: 0.36rem;
    font-size: 0.26rem;
    color: #333;
    margin-top: 0.27rem;
    display: -webkit-box;
    overflow: hidden;
    white-space: normal !important;
    text-overflow: ellipsis;
    word-wrap: break-word;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    transition: all 0.3s;
    &.target_show {
      display: block;
    }
  }
  .target_btn {
    margin-top: 0.3rem;
    font-size: 0.24rem;
    display: flex;
    justify-content: center;
    align-items: center;
    width: calc(100% + 0.5rem);
    color: #999;
    margin-left: -0.25rem;

    height: 0.75rem;
    .iconfont {
      color: #999;
      display: inline-block;
      transform: rotate(90deg) translateX(1px);
      &.shang {
        transform: rotate(-90deg) translateX(-1px);
      }
    }
  }
  .p1 {
    font-size: 0.3rem;
    color: #333;
    font-weight: bold;
    display: inline-block;
  }
  .span1 {
    font-size: 0.2rem;
    color: #999;
    padding-left: 0.2rem;
  }
  .p2 {
    font-size: 0.26rem;
    color: #333;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 3;
    overflow: hidden;
  }
  .p2-more {
    font-size: 0.26rem;
    color: #333;
  }
  .more {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 0.3rem;
    span {
      color: #595757;
    }
  }
}
/**类别样式**/
.product-category {
  display: flex;
  flex-wrap: wrap;
  p {
    padding: 0 0.19rem;
    max-width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 0.42rem;
    color: #ff5c00;
    border: 1px solid #ff5c00;
    margin-right: 0.2rem;
    margin-top: 0.14rem;
    border-radius: 3px;
    span {
      display: block;
    }
  }
}
/**公司信息 **/
.exhibition-data {
  background-color: #fff;
  margin-top: 0.2rem;

  &-list {
    padding: 0.3rem;
    display: flex;
    img {
      width: 1.2rem;
      height: 1.2rem;
      border-radius: 50%;
      border: 1px solid #efefef;
      margin-right: 0.2rem;
    }
    .text {
      width: 5.4rem;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      .title {
        display: flex;
        align-items: center;
        justify-content: space-between;
        p {
          text-overflow: ellipsis;
          white-space: nowrap;
          overflow: hidden;
          // width: 80%;
          min-height: 0.34rem;
        }
      }
      .center {
        margin-top: 0.08rem;
        .span1 {
          font-size: 0.22rem;
          color: #999;
        }
        .span2 {
          font-size: 0.22rem;
          color: #666;
        }
      }
      .bottom {
        margin-top: 0.14rem;
        color: #666;
        display: flex;
        align-items: center;
        .icon1 {
          color: #fe781d;
          transform: scale(1.4);
          display: inline-block;
          margin-right: 0.1rem;
        }
        .icon2 {
          color: #1296db;
          transform: scale(1.4);
          display: inline-block;
          margin-right: 0.1rem;
        }
      }
      .tongji {
        margin-top: 0.14rem;
        display: flex;
        .tips {
          padding: 0 0.12rem;
          height: 0.36rem;
          background-color: #f2f2f2;
          border-radius: 4px;
          display: flex;
          align-items: center;
          justify-content: center;
          margin-right: 0.2rem;
          .b-span {
            color: #333;
            font-size: 0.22rem;
          }
          .r-span {
            color: #ff5c00;
            font-size: 0.22rem;
          }
        }
      }
      p {
        font-size: 0.3rem;
        font-weight: bold;
        color: #333;
      }
    }
  }
}
/**产品详情  **/
.comm_text {
  background: #fff;
  color: #333;
  padding: 0 0 0.35rem 0;
  p {
    line-height: 0.48rem;
    font-size: 0.28rem;
  }
  img {
    display: block;
  }
  .int-text {
    padding: 0.2rem 0.3rem;
  }
}
//展品列表
.exhibits {
  height: 1rem;
  border-bottom: 1px solid #f5f5f5;
  p {
    padding: 0.3rem 0 0.33rem 0.31rem;
    font-size: 0.3rem;
    color: #333;
    font-weight: bold;
  }
}
.exhibits_list {
  background: #fff;
  border-radius: 0.3rem;
  padding: 0.04rem 0.3rem 0 0.2rem;
  color: #333;
  .title {
    height: 0.77rem;
    display: flex;
    justify-content: center;
    align-items: center;
    span {
      font-size: 0.32rem;
      font-weight: bold;
      margin: 0 0.2rem;
    }
    img {
      height: 0.2rem;
      width: 0.42rem;
    }
  }
  .ex_list {
    .item {
      &:last-child {
        .item_div {
          border: none;
        }
      }
    }
    .item_div {
      padding: 0.26rem 0;
      border-bottom: 1px solid #e6e6e6;
      display: flex;

      .img_div {
        flex-shrink: 0;
        position: relative;
        height: 1.6rem;
        width: 1.6rem;
        border-radius: 2px;
        border: 1px solid #e6e6e6;
        overflow: hidden;
        margin-right: 0.2rem;
        img {
          width: 100%;
          height: 100%;
        }
        .d_tag {
          position: absolute;
          z-index: 1;
          width: 0.8rem;
          height: 0.35rem;
          display: flex;
          align-items: center;
          justify-content: space-between;
          background: #ff5c00;
          padding: 0 0.13rem 0 0.05rem;
          box-sizing: border-box;
          border-radius: 0 0 0 0.1rem;
          color: #fff;
          font-size: 0.2rem;
          right: 0;
          top: 0;
          .iconfont {
            font-size: 0.36rem;
          }
        }
        .img-v {
          position: absolute;
          z-index: 1;
          width: 0.38rem;
          display: flex;
          align-items: center;
          justify-content: center;
          background: #fff;

          box-sizing: border-box;
          color: #0190fe;
          border: 1px solid #0190fe;
          left: 0;
          top: 0;
        }
        .play_video {
          width: 100%;
          height: 100%;
          position: absolute;
          top: 0;
          left: 0;
          background: rgba(0, 0, 0, 0.2);
          display: flex;
          align-items: center;
          justify-content: center;
          z-index: 2;
          i {
            font-size: 0.72rem;
            color: #fff;
          }
        }
      }
      .item_info {
        max-width: calc(100% - 1.8rem);
        p {
          font-size: 0.3rem;
          font-weight: bold;
          margin-top: 0.1rem;
          &.item_text {
            color: #666;
            font-weight: inherit;
            font-size: 0.24rem;
            margin-top: 0.1rem;
          }
        }
      }
    }
  }
  .more_btn {
    font-size: 0.26rem;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 0.75rem;
    width: calc(100% + 0.5rem);
    color: #595757;
    .iconfont {
      color: #999;
      display: inline-block;
      transform: rotate(90deg) translateX(1px);
      &.shang {
        transform: rotate(-90deg) translateX(-1px);
      }
    }
  }
}
.ex-list {
  position: fixed;
  right: 0.3rem;
  bottom: 1.18rem;
}
.shop_footer {
  display: flex;
  height: 0.98rem;
  width: 100%;
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  background: #fff;
  box-shadow: 0 0 5px 0 rgba(0, 0, 0, 0.2);
  box-sizing: content-box;
  z-index: 10;
  .f_item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-direction: column;
    color: #808080;
    padding-top: 0.05rem;
    border-right: 1px solid #eee;
    width: 1.09rem;
    &.love {
      color: #ff5c00;
      .iconfont {
        color: transparent;
        background: linear-gradient(to right, #ffa06a, #ff5c00);
        -webkit-background-clip: text;
      }
    }
    .iconfont {
      font-size: 0.58rem;
      &.i_love {
        transform: scale(1.1);
      }
    }
    p {
      font-size: 0.2rem;
      position: relative;
      top: -0.1rem;
    }
  }
  .f_btn {
    flex-grow: 1;
    display: flex;
    padding: 0.13rem 0.24rem;
    .van-button {
      height: 0.72rem;
      line-height: 0.72rem;
      font-size: 0.28rem;
      width: 100%;
      color: #fff;
      text-align: center;
      display: block;
      position: relative;
      .hiddenBtn {
        width: 100%;
        height: 100%;
        display: block;
        background: black;
        color: #fff;
        position: absolute;
        top: 0;
        left: 0;
        opacity: 0;
      }
      &:first-child {
        border-radius: 0.06rem;
        background: linear-gradient(90deg, #f10100 0%, #ff4e17 100%);
      }
      &:last-child {
        border-radius: 0.06rem;
        background: linear-gradient(to left, rgb(255, 186, 0), rgb(255, 166, 0));
      }
      &.already {
        background: #999;
        color: #fff;
      }
    }
  }
}
.loading {
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  img {
    width: 18px;
    height: 18px;
    display: inline-block;
    margin-right: 5px;
    animation: 1s loader-01 linear infinite;
  }
}
@keyframes loader-01 {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
</style>
